
import Vue from 'vue'
import SectionPanel from '@/categories/components/SectionPanel.vue'
import { displayItemsCount } from '@/categories/const'
import { ProductType } from '@/types'
import debounce from 'lodash/debounce'
import { BQ_EVENT_NAMES, raksulBQEventTracker} from '@/common/utils'
import { BQImpressionData } from '../types'

interface Data {
  visibleItemsCount: number,
  trackedImpressions: BQImpressionData[]
}

export default Vue.extend({
  components: {
    SectionPanel
  },
  props: {
    products: {
      type: Array as() => ProductType[],
      required: true
    },
    sectionTitle: {
      type: String,
      required: false,
      default: ''
    },
    totalItemsCount: {
      type: Number,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  data(): Data {
    return {
      visibleItemsCount: 0,
      trackedImpressions: []
    }
  },
  computed: {
    isTabletOrBelow(): boolean {
      return window.innerWidth <= 1024
    },
    displayShowMoreBtn(): boolean {
      return this.hiddenItemsCount > 0
    },
    visibleItemsList(): ProductType[] {
      if (this.totalItemsCount) {
        return this.products
      }
      return this.products.filter((group, index) => {
        return index < this.visibleItemsCount
      })
    },
    hiddenItemsCount(): number {
      if (this.totalItemsCount) {
        return this.totalItemsCount - this.products.length
      }
      return this.products.length - this.visibleItemsCount
    }
  },
  watch: {
    trackedImpressions: {
      handler: debounce(function(newVal) {
        if (newVal.length === 0) {
          return
        }
        raksulBQEventTracker({
          eventName: BQ_EVENT_NAMES.VIEW_PRODUCT_CATEGORY,
          data: {
            viewedProducts: JSON.stringify(newVal)
          }
        })
        this.resetTrackImpressions()
      }, 1000)
    }
  },
  mounted(): void {
    if (this.isTabletOrBelow) {
      this.visibleItemsCount = displayItemsCount.tabletAndBelow
    } else {
      this.visibleItemsCount = displayItemsCount.desktop
    }
  },
  methods: {
    resetTrackImpressions() {
      this.trackedImpressions = []
    },
    productURL(product: any): string {
      return product ? `/products/${product.productId}?sku=${product.id}` : ''
    },
    showMoreItems(): void {
      if (this.totalItemsCount) {
        this.$emit('loadMore')
        return
      }
      if (this.isTabletOrBelow) {
        this.visibleItemsCount += displayItemsCount.tabletAndBelow
      } else {
        this.visibleItemsCount += displayItemsCount.desktop
      }
    },
    trackImpression(value: BQImpressionData) {
      this.trackedImpressions.push(value)
    }
  }
})
